import { APP_VERSION, CORE_INTERCEPTORS_URL_REGEX_PATTERNS_FILTER, CoreRoutes, provideCore, UserStore } from '@aeins/core';
import { CustomInterceptor } from '@aeins/custom.interceptor';
import { AdditionalCheckHandler, RoutingHandler } from '@aeins/routing.handler';
import { API_BASE_URL } from '@aeins/sharedfrontendapi';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, inject, isDevMode, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideIonicAngular } from '@ionic/angular';
import { provideTranslateService, TranslateCompiler } from '@ngx-translate/core';
import { AppComponent } from 'app/core/app';
import { PageComponent } from 'app/core/page';
import { AppService } from 'app/services/app/app.service';
import { environment } from 'environments/environment';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { register } from 'swiper/element/bundle';

import packageJson from '../package.json';

if (environment.production) {
    enableProdMode();
}

register();

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({
            eventCoalescing: true,
            runCoalescing: true,
        }),
        importProvidersFrom(BrowserModule, ReactiveFormsModule),
        provideTranslateService({
            compiler: {
                provide: TranslateCompiler,
                useClass: TranslateMessageFormatCompiler,
            },
        }),
        provideRouter(CoreRoutes(PageComponent, RoutingHandler, AdditionalCheckHandler)),
        provideHttpClient(withInterceptors([CustomInterceptor])),
        provideIonicAngular({
            rippleEffect: false,
            innerHTMLTemplatesEnabled: true,
        }),
        provideCore(),
        provideAppInitializer(() => inject(AppService).init()),
        {
            provide: APP_VERSION,
            useFactory: () => packageJson.version,
        },
        {
            provide: 'server',
            useValue: environment.server,
        },
        {
            provide: API_BASE_URL,
            useValue: environment.server,
        },
        {
            provide: CORE_INTERCEPTORS_URL_REGEX_PATTERNS_FILTER,
            useFactory: () => [new RegExp(environment.server)],
        },
        {
            provide: UserStore,
            useFactory: () => ({ userId: () => null }),
        },
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
});
